import { render, staticRenderFns } from "./SaleManagementDetail.vue?vue&type=template&id=21ee0629&scoped=true&"
import script from "./SaleManagementDetail.vue?vue&type=script&lang=ts&"
export * from "./SaleManagementDetail.vue?vue&type=script&lang=ts&"
import style0 from "./SaleManagementDetail.vue?vue&type=style&index=0&id=21ee0629&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ee0629",
  null
  
)

export default component.exports